import {createSlice} from "@reduxjs/toolkit";
import {Building} from "../../models/Building";
/**
 * Building Slice
 * - Takes in building objects in db format
 * - Stores building objects in frontend format
 * - stores data as dict of dict:
 * data: { buildingId1: {Building obj 1},  buildingId2: {Building obj 2}, ... }
 */
const initialState = {
  loading: false,
  data: {},
  error: "",
};

const buildingSlice = createSlice({
  name: "building",
  initialState,

  reducers: {
    addBuilding: (state, action) => {
      let buildingCopy = {...state.data};
      let newBuilding = {
        buildingId: action.payload.buildingId,
        buildingName: action.payload.buildingName,
      };
      buildingCopy[action.payload.buildingId] = newBuilding;

      state.data = buildingCopy;
    },
    updateBuilding: (state, action) => {
      let bid = action.payload.buildingId;
      state.data[bid].buildingName = action.payload.buildingName;
    },
    setBuilding: (state, action) => {
      let buildingList = action.payload;
      let newBuildingDict = {};
      for (let building of buildingList) {
        building = JSON.parse(JSON.stringify(new Building(building)));
        newBuildingDict[building.buildingId] = building;
      }
      state.data = newBuildingDict;
    },
    deleteBuilding: (state, action) => {
      const key = action.payload.buildingId;
      delete state.data[key];
    },
  },
});

export const {setBuilding, addBuilding, updateBuilding, deleteBuilding} =
  buildingSlice.actions;

export default buildingSlice.reducer;
